// facebook see: https://developers.facebook.com/docs/ads-for-websites/pixel-events/v2.11
// gtag see: https://developers.google.com/analytics/devguides/collection/gtagjs/enhanced-ecommerce
const mergeCustomAnalyticsData = data =>
    Object.assign(window.custom_analytics_data || {}, data)

export const trackWaitlist = emailAddress => {
    try {
        window.oztix_ipa &&
            window.oztix_ipa(
                'event',
                'add_to_waitlist',
                mergeCustomAnalyticsData({
                    emailAddress,
                }),
            )
    } catch (e) {}
}

export const trackRegistration = emailAddress => {
    try {
        window.oztix_ipa &&
        window.oztix_ipa(
            'event',
            'registration',
            mergeCustomAnalyticsData({
                emailAddress,
            }),
        )
    } catch (e) {}
}

export const trackIdle = () => {
    try {
        window.gtag &&
            window.gtag(
                'event',
                'idle',
                mergeCustomAnalyticsData({}),
            )
    } catch (e) {}
}

export const trackAddToCart = ({ eventName, inventory, total }) => {
    try {
        window.gtag &&
            window.gtag(
                'event',
                'add_to_cart',
                mergeCustomAnalyticsData({
                    items: inventory.map(i => ({
                        id: i.id,
                        name: `${eventName} - ${i.name}`,
                        quantity: i.quantity,
                        price: i.price,
                        category: eventName,
                    })),
                    // custom property
                    value: total,
                }),
            )

        window.fbq_single &&
            window.fbq_single(
                'track',
                'AddToCart',
                mergeCustomAnalyticsData({
                    contents: inventory.map(i => ({
                        id: i.id,
                        quantity: i.quantity,
                        item_price: i.price,
                    })),
                    content_type: 'product',
                    value: total,
                    currency: 'AUD',
                }),
            )

        window.oztix_ipa &&
            window.oztix_ipa(
                'event',
                'add_to_cart',
                mergeCustomAnalyticsData({
                    items: inventory.map(i => ({
                        id: i.id,
                        name: `${eventName} - ${i.name}`,
                        quantity: i.quantity,
                        price: i.price,
                        category: eventName,
                    })),
                }),
            )
    } catch (e) {}
}

export const trackCheckoutProgress = step => {
    try {
        window.gtag &&
            window.gtag(
                'event',
                'checkout_progress',
                mergeCustomAnalyticsData({
                    checkout_step: step,
                }),
            )

        window.oztix_ipa &&
            window.oztix_ipa(
                'event',
                'checkout_progress',
                mergeCustomAnalyticsData({
                    checkout_step: step,
                }),
            )
        window.oztix_ipa &&
            window.oztix_ipa(
                'event',
                'add_to_cart',
                mergeCustomAnalyticsData({
                    items: inventory.map(i => ({
                        id: i.id,
                        name: `${eventName} - ${i.name}`,
                        quantity: i.quantity,
                        price: i.price,
                        category: eventName,
                    })),
                }),
            )
    } catch (e) {}
}

export const trackBeginCheckout = ({ eventName, inventory, total, cartId }) => {
    try {
        window.gtag &&
            window.gtag(
                'event',
                'begin_checkout',
                mergeCustomAnalyticsData({
                    oztix_cart_id: cartId,
                    items: inventory.map(i => ({
                        id: i.id,
                        name: `${eventName} - ${i.name}`,
                        quantity: i.quantity,
                        price: i.price,
                        category: eventName,
                    })),
                }),
            )

        window.fbq_single &&
            window.fbq_single(
                'track',
                'InitiateCheckout',
                mergeCustomAnalyticsData({
                    contents: inventory.map(i => ({
                        id: i.id,
                        quantity: i.quantity,
                        item_price: i.price,
                    })),
                    content_type: 'product',
                    value: total,
                    currency: 'AUD',
                    oztix_cart_id: cartId,
                    num_items: inventory
                        .map(i => i.quantity)
                        .reduce((init, current) => init + current, 0),
                }),
            )

        window.oztix_ipa &&
            window.oztix_ipa(
                'event',
                'begin_checkout',
                mergeCustomAnalyticsData({
                    oztix_cart_id: cartId,
                    items: inventory.map(i => ({
                        id: i.id,
                        name: `${eventName} - ${i.name}`,
                        quantity: i.quantity,
                        price: i.price,
                        category: eventName,
                    })),
                }),
            )
    } catch (e) {}
}

export const trackShare = (network, url) => {
    try {
        window.gtag &&
            window.gtag(
                'event',
                'share',
                mergeCustomAnalyticsData({
                    method: network,
                    event_action: 'share',
                    content_id: url,
                }),
            )

        window.oztix_ipa &&
            window.oztix_ipa(
                'event',
                'share',
                mergeCustomAnalyticsData({
                    method: network,
                    event_action: 'share',
                    content_id: url,
                }),
            )
    } catch (e) {}
}

export const trackPurchase = ({ eventName, total, cartId, inventory }) => {
    try {
        window.gtag &&
            window.gtag(
                'event',
                'purchase',
                mergeCustomAnalyticsData({
                    transaction_id: cartId,
                    value: total,
                    currency: 'AUD',
                    items: inventory.map(i => ({
                        id: i.id,
                        name: `${eventName} - ${i.name}`,
                        quantity: i.quantity,
                        price: i.price,
                        category: eventName,
                    })),
                }),
            )

        if (window.gtag && window.adwordsConversions.length > 0) {
            for (var i = 0; i < window.adwordsConversions.length; i++) {
                window.gtag('event', 'conversion', {
                    send_to: window.adwordsConversions[i],
                    value: total,
                    currency: 'AUD',
                    transaction_id: cartId,
                })
            }
        }

        window.fbq_single &&
            window.fbq_single(
                'track',
                'Purchase',
                mergeCustomAnalyticsData({
                    contents: inventory.map(i => ({
                        id: i.id,
                        quantity: i.quantity,
                        item_price: i.price,
                    })),
                    content_type: 'product',
                    value: total,
                    currency: 'AUD',
                }),
            )

        window.oztix_ipa &&
            window.oztix_ipa(
                'event',
                'purchase',
                mergeCustomAnalyticsData({
                    transaction_id: cartId,
                    value: total,
                    currency: 'AUD',
                    items: inventory.map(i => ({
                        id: i.id,
                        name: `${eventName} - ${i.name}`,
                        quantity: i.quantity,
                        price: i.price,
                        category: eventName,
                    })),
                }),
            )
    } catch (e) {}
}

export const trackMerchantWarrior = (ev) => {
    try {
        window.gtag && window.gtag('event', 'merchantwarrior', mergeCustomAnalyticsData(ev))
        window.oztix_ipa && window.oztix_ipa('error', 'merchantwarrior', mergeCustomAnalyticsData(ev))
    } catch (e) {}
}



// WEBPACK FOOTER //
// ./Features/Shared/analytics.js